const faqs = [
  {
    category: "Report Related FAQs",
    question: "I’m visiting this website for the first time. How do I trust your service quality?",
    answer: "We encourage you to explore our website and check sample company profiles and report overviews. For any questions or sample requests, please contact us at data.pi@zohomail.in. We’ll be happy to share relevant examples and set up a product walkthrough."
  },
  {
    category: "Report Related FAQs",
    question: "Samples are available for all the reports published by DataPi?",
    answer: "Yes! You can request a free sample of any available report or company profile. For upcoming studies, we can share demo content to help you evaluate before purchase."
  },
  {
    category: "Report Related FAQs",
    question: "What if I have more questions or need a custom report?",
    answer: "If you have specific research requirements or need customization, simply fill out the query form on the report page or email us at data.pi@zohomail.in. We’ll get back to you promptly."
  },
  {
    category: "Report Related FAQs",
    question: "How do I make sure my requirements are clearly understood?",
    answer: "Our research team will review your needs carefully. If needed, we’ll arrange a call to discuss your goals and design a customized solution."
  },
  {
    category: "Report Related FAQs",
    question: "What is the cost and delivery time for customized reports?",
    answer: "Pricing and timelines vary based on scope. Once we confirm your deliverables, we’ll share a quote and timeline with you. Some basic customization is complimentary."
  },
  {
    category: "Report Related FAQs",
    question: "How often are DataPi reports updated?",
    answer: "We update our reports regularly, usually every 6–12 months, to ensure you have the latest market insights."
  },
  {
    category: "Report Related FAQs",
    question: "What if I can’t find the report I need?",
    answer: "No problem! If you don’t see a report listed, email us at data.pi@zohomail.in, we may already have the data or can develop it for you."
  },
  {
    category: "Report Related FAQs",
    question: "What services do you offer before purchase?",
    answer: "We provide free sample access, personalized consultations, and pre-purchase support to help you choose the right report."
  },
  {
    category: "Report Related FAQs",
    question: "What formats are the reports delivered in?",
    answer: "Reports are usually shared in PowerPoint (PDF), and spreadsheet formats. If you need any other format, let us know!"
  },
  {
    category: "Report Related FAQs",
    question: "Do you offer discounts?",
    answer: "Yes, we offer special pricing for students, startups, and educational institutions. Reach out to data.pi@zohomail.in to learn more."
  },
  {
    category: "Ordering and Delivery",
    question: "How can I purchase a report?",
    answer: "Use the “Buy Now” option on the report page, or email us your order details at data.pi@zohomail.in. Payment can be made via bank transfer or card."
  },
  {
    category: "Ordering and Delivery",
    question: "How soon will I receive the report?",
    answer: "You’ll receive your report within 5–48 hours after payment confirmation. Orders placed on weekends or holidays are delivered on the next working day."
  },
  {
    category: "Ordering and Delivery",
    question: "How will the report be delivered?",
    answer: "Your report will be sent to your registered email in PDF format. Please check your spam folder too, just in case!"
  },
  {
    category: "Ordering and Delivery",
    question: "What are the available ordering methods?",
    answer: "You can place your order directly through our website or email us at data.pi@zohomail.in with your requirements."
  },
  {
    category: "License Type and Purchase Options",
    question: "What are single-user, multi-user, and enterprise licenses?",
    answer: "Single-user: Access for one person. Multi-user: Access for up to five users. Enterprise: Full access for your entire organization."
  },
  {
    category: "License Type and Purchase Options",
    question: "Can I buy individual chapters or sections?",
    answer: "Usually, we recommend the complete report for context, but if you have specific needs, email data.pi@zohomail.in we’ll see what’s possible."
  },
  {
    category: "Payments and Invoicing",
    question: "What payment methods do you accept?",
    answer: "We accept major credit/debit cards, wire transfers, and online payment gateways."
  },
  {
    category: "Payments and Invoicing",
    question: "Is your online payment process secure?",
    answer: "Yes, we use trusted, secure payment gateways. We do not store your card details."
  },
  {
    category: "Payments and Invoicing",
    question: "Will I get an invoice for my purchase?",
    answer: "Absolutely. You’ll receive a digital invoice once your payment is processed. We can also issue pro-forma invoices on request."
  },
  {
    category: "Payments and Invoicing",
    question: "What are your payment terms?",
    answer: "All payments are non-refundable. We recommend clarifying any questions with our team before you buy."
  },
  {
    category: "Payments and Invoicing",
    question: "I’m facing payment issues, what should I do?",
    answer: "Payment failures usually happen due to billing detail mismatches. Please double-check your information or email us at data.pi@zohomail.in for help."
  },
  {
    category: "Payments and Invoicing",
    question: "I see a ‘Transaction cannot be processed’ message What does this mean?",
    answer: "It could be due to a billing address mismatch or card limit. Please confirm with your bank or get in touch with us for assistance."
  },
  {
    category: "Post-Sale Queries",
    question: "Can I talk to an analyst about my purchased report?",
    answer: "Yes, every purchase includes limited free analyst support for Q&A and deeper insights."
  },
  {
    category: "Post-Sale Queries",
    question: "What if my report is missing some information I expected?",
    answer: "We offer post-sale customization. Email data.pi@zohomail.in with your specific needs, and we’ll see how we can help."
  },
  {
    category: "Post-Sale Queries",
    question: "Is post-sale customization free?",
    answer: "A basic level of customization is free. For larger modifications, our team will share the scope and additional costs in advance."
  },
  {
    category: "Post-Sale Queries",
    question: "How can I contact DataPi?",
    answer: "Email us anytime at data.pi@zohomail.in, we’ll respond quickly to assist you!"
  }
];

export default faqs;
